import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LocalityApi {
  private localities$?: Observable<Localities[]>;
  private readonly http = inject(HttpClient);

  get(zipCode: number): Observable<Localities> {
    return this.loadLocalities().pipe(map((localities) => this.getLocalLocalities(localities, zipCode)));
  }

  prefetchLocalities(): Observable<Localities[]> {
    return this.loadLocalities();
  }

  private loadLocalities(): Observable<Localities[]> {
    if (!this.localities$) {
      this.localities$ = this.http.get<Localities[]>('assets/files/localities.json').pipe(shareReplay(1));
    }

    return this.localities$;
  }

  private getLocalLocalities(localities: Localities[], zipcode: number): Localities {
    const locality = localities.find((local) => local.zipcode === zipcode.toString());
    return locality ?? null;
  }
}

export interface Localities {
  zipcode: string;
  localities: string[];
  region?: string;
  dgo?: {
    power: string;
    gas: string;
  };
}
